import './Home.css';
import Video from "../images/FirstPageImage.png";
import LogosImage1 from "../images/LogosImage1.jpg"
import LogosImage2 from "../images/LogosImage2.png"
import LogosImage3 from "../images/LogosImage3.jpg"
import LogosImage4 from "../images/LogosImage4.jpg"


function Home() {
  return (
    <div>

      <section id= "FirstPage">      
        {/* ---------------------------------------- First Pagae----------------------------------------------- */}
        <div className = "section-container">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div id = "FirstPageText">
                  <h1 style = {{marginBottom: "5%"}}>Προσομοίωση επιβατικών μετακινήσεων</h1>

                  <p>Η υπηρεσία προσομοίωσης επιβατικών μετακινήσεων δημιουργήθηκε στο πλαίσιο της Ερευνητικής Υποδομής EN.I.R.I.S.S.T. 
                    (Intelligent Research Infrastructure, Shipping, Supply Chain, Transport and Logistics) και συγκεκριμένα της "Πλατφόρμας Επιβατικών Μετακινήσεων".
                  </p>
                  <p>Μέσω της υπηρεσίας αυτής μπορείς να έχεις πρόσβαση σε δεδομένα προσφοράς και ζήτησης για τις οδικές, 
                    σιδηροδρομικές, θαλάσσιες και αεροπορικές μετακινήσεις στην Ελλάδα, έτσι όπως προκύπτουν από συστήματα προσομοίωσης.
                    </p> 
                </div>

              </div>
              <div className="col-lg-5" id = "VideoPos">
                <img src={Video} width="400" height="400" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ----------------------------------------------------- SECTION 2 OF PAGE 1------------------------------ */}
      <div className="container" id = "MidSection">
        <div className="row">
            <div className="col-lg-7">
              <div style = {{ marginTop: "40%"}}>
                <h3><strong> Εταίροι Ανάπτυξης Υπηρεσίας</strong></h3>

                <p>Η υπηρεσία προσομοίωσης επιβατικών μετακινήσεων αναπτύχθηκε από την ερευνητική ομάδα του Εργαστηρίου Συγκοινωνιακής Τεχνικής του Τομέα Μεταφορών και Διαχείρισης Έργων
                   του Αριστοτελείου Πανεπιστημίου Θεσσαλονίκης και την ερευνητική ομάδα του Εργαστηρίου Μεταφορών και Λήψης Αποφάσεων του Τμήματος Ναυτιλίας και Επιχειρηματικών Υπηρεσιών του Πανεπιστημίου Αιγαίου (TransDem)
                </p>  
              </div>
            </div>
            <div className="col-lg-5" style ={{ marginTop: "7%"}}>
              <div style={{display: "flex"}}>
                <img src={LogosImage1} width="300" height="250" alt=""/>
                <img src={LogosImage2} width="250" height="200" alt=""/>
              </div >
              <div style={{display: "flex"}}>
                <img src={LogosImage3} width="230" height="200" alt=""/>
                <img src={LogosImage4} width="250" height="200" alt=""/>
              </div>  
            </div>
        </div>
      </div>

      <div className='container-fluid' id = "PlatformLink">
          <hr style = {{height: "2px", width: "20%", backgroundColor: "orange"}}></hr>
          <h3 style = {{margin: "0 auto"}}><strong>Πλατφόρμα Υποδομών</strong></h3>
          <p style = {{margin: "0 auto"}}>Περισσότερες πληροφορίες για τις υποδομές μεταφορών</p>
          <p style = {{margin: "0 auto"}}>μπορείτε να βρείτε στην "Πλατφόρμα Υποδομών".</p> 
          <a href = "https://wiki.enirisst.uop.gr/mediawiki/index.php/%CE%91%CF%81%CF%87%CE%B9%CE%BA%CE%AE_%CF%83%CE%B5%CE%BB%CE%AF%CE%B4%CE%B1">
            <button id = "PlatfromButton"> Μετάβαση στην πλατφόρμα</button>
          </a>
        
      </div>

    </div>
  );
}

export default Home;
